import { createContext } from 'react';
import { Variants, Transition, DragElastic, BoundingBox, PanInfo } from 'framer-motion';

interface AnimationVariants {
	direction: number;
	w: number;
}

export const ANIMATION_VARIANTS: Variants = {
	exit: ({ direction, w }: AnimationVariants) => ({
		zIndex: 0,
		x: direction < 0 ? w : -w
	}),
	enter: ({ direction, w }: AnimationVariants) => ({
		x: direction > 0 ? w : -w
	}),
	center: () => ({
		zIndex: 1,
		x: 0
	})
};

// export const ANIMATION_VARIANTS: Variants = {
// 	enter: direction => {
// 		return {
// 			x: direction > 0 ? 500 : -500
// 		};
// 	},
// 	center: {
// 		zIndex: 1,
// 		x: 0
// 	},
// 	exit: direction => {
// 		return {
// 			zIndex: 0,
// 			x: direction < 0 ? 500 : -500
// 		};
// 	}
// };

export const ANIMATION_TRANSITION = {
	x: { type: 'tween', duration: 0.3 }
};

export const DRAG_CONSTRAINTS = { left: 0, right: 0, top: 0, bottom: 0 };

export const DRAG_ELASTIC = 1;

interface CarouselContextType {
	animationVariants?: Variants;
	animationTransition?: Transition;
	direction?: number;
	w?: number;
	disableAnimation?: boolean;
	carouselItemIndex?: number;
	disableSwipe?: boolean;
	dragElastic?: DragElastic;
	dragConstraints?: BoundingBox;
	handleDragEnd?: (event: MouseEvent | TouchEvent | PointerEvent, { offset, velocity }: PanInfo) => void;
}

// onDragEnd?: (DragEventHandler<HTMLDivElement> & ((event: MouseEvent | TouchEvent | PointerEvent, info: PanInfo) => void)) | undefined

const CarouselContext = createContext<CarouselContextType>({});

export default CarouselContext;
